import { Sparkles, Database, ShieldCheck, Wand2 } from "lucide-react";
import SEOHead from "@/components/SEOHead";
import SqlBuilder from "@/components/SqlBuilder";
import ToolPageShell from "@/components/tools/ToolPageShell";

const faqs = [
  { q: "What SQL dialect does it use?", a: "PostgreSQL by default. Mention MySQL, SQLite, SQL Server, BigQuery or Snowflake in your prompt and it will adapt." },
  { q: "Can I include my schema?", a: "Yes — paste your tables and columns into the prompt. The generated SQL will use them and call out any assumptions it had to make." },
  { q: "Should I run it directly in production?", a: "Always review the SQL first, especially DELETE/UPDATE statements. Treat it as a confident first draft, not a final answer." },
  { q: "Is my prompt stored?", a: "No. We send the request to the AI model and return the SQL. Nothing is logged on our servers." },
];

const SqlBuilderPage = () => (
  <>
    <SEOHead
      title="Free AI SQL Query Builder — Plain English to SQL"
      description="Describe a query in plain English and get working SQL with explanation and assumptions. PostgreSQL, MySQL, SQLite and more. Free."
      path="/tools/sql-builder"
      keywords="SQL builder, text to SQL, AI SQL generator, plain english to SQL, SQL query generator, free SQL tool"
      breadcrumbs={[
        { name: "Home", path: "/" },
        { name: "Free Tools", path: "/tools" },
        { name: "SQL Builder", path: "/tools/sql-builder" },
      ]}
      jsonLd={[
        { "@context": "https://schema.org", "@type": "WebApplication", name: "NETIUS SQL Builder", url: "https://netius.com/tools/sql-builder", applicationCategory: "DeveloperApplication", operatingSystem: "Any (Web)", offers: { "@type": "Offer", price: "0", priceCurrency: "USD" } },
        { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) },
      ]}
    />
    <ToolPageShell
      title="SQL Query Builder"
      subtitle="Describe what you want from your database. Get clean SQL with an explanation and the assumptions the AI made."
      badges={[
        { icon: Sparkles, label: "AI-powered" },
        { icon: Database, label: "Postgres, MySQL & more" },
        { icon: ShieldCheck, label: "Nothing stored" },
      ]}
      featuresHeading="What it does"
      features={[
        { icon: Wand2, title: "Plain-English to SQL", description: "Skip the syntax — describe the question and get a working query." },
        { icon: Database, title: "Schema-aware", description: "Paste your tables and columns and the SQL will use the right names." },
        { icon: Sparkles, title: "Explains itself", description: "Every result includes the joins, filters and assumptions in plain English." },
      ]}
      faqSubheading="Quick answers about the SQL builder."
      faqs={faqs}
      softCtaText="Need a real database, dashboards or reporting built for your business?"
    >
      <SqlBuilder />
    </ToolPageShell>
  </>
);

export default SqlBuilderPage;